<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="c01"><a id="page2"></a><span href="#/OEBPS/toc#c01" title="Link target outside of Sample">1</span></h1>
<h1 class="chapter-head"><span class="bborder"><span href="#/OEBPS/toc#c01" title="Link target outside of Sample">Breakfast and Smoothies</span></span></h1>
<p class="figure"><img alt="" src="OEBPS/images/3-1.jpg" style="height:60vh"/></p>
<p class="ChapbText">When I start my day off by eating something healthy, I feel motivated to keep eating lighter recipes all day long. I’m not going to have a delicious Nutrient-Rich Kale Smoothie (<a href="#/OEBPS/sect9#page20">here</a>) and then follow that up with a lunch of a burger and fries. It just doesn’t make sense! From Banana Nut Bread (<a href="#/OEBPS/sect1#page4">here</a>) to Breakfast Stuffed Peppers (<a href="#/OEBPS/sect7#page16">here</a>) and everything in between, there are plenty of ways to make sure you start your day off right.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c01.vue?3f3aa456